import React from "react";
import ReactDOM from "react-dom/client";
// Ensure canvas 2D contexts used for frequent readbacks are created with
// `{ willReadFrequently: true }` to avoid repeated getImageData warnings
// (see https://html.spec.whatwg.org/multipage/canvas.html#concept-canvas-will-read-frequently).
try {
  const _orig = HTMLCanvasElement.prototype.getContext;
  HTMLCanvasElement.prototype.getContext = function (type, attrs) {
    if (type === '2d') {
      attrs = Object.assign({}, attrs, { willReadFrequently: true });
    }
    return _orig.call(this, type, attrs);
  };
} catch (e) {
  // Not fatal; some environments may not expose HTMLCanvasElement
}
import "@/index.css";
import App from "@/App";

function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  if (!("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js");

      if (registration.waiting) {
        window.dispatchEvent(
          new CustomEvent("swUpdateReady", { detail: { registration } }),
        );
      }

      registration.addEventListener("updatefound", () => {
        const installingWorker = registration.installing;
        if (!installingWorker) {
          return;
        }

        installingWorker.addEventListener("statechange", () => {
          if (
            installingWorker.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            window.dispatchEvent(
              new CustomEvent("swUpdateReady", { detail: { registration } }),
            );
          }
        });
      });
    } catch (error) {
      console.error("ServiceWorker registration failed:", error);
    }
  });
}

registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
